import React from "react";
import { Pagination } from "react-admin";

const perPage = 50;
const pagination = <Pagination rowsPerPageOptions={[50, 100, 500]} />;

const GlobalPagination = { perPage, pagination };

export default GlobalPagination;
